import React, { useRef } from "react";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";
import { translationConstants } from "../../../constants";

const ExportComponent = ({
  dataToExport,
  columns,
  filename,
  isServerSide,
  onClick,
}) => {
  const { t } = useTranslation();
  const csvLinkRef = useRef(null);

  const exportCSV = () => csvLinkRef.current.link.click();

  return (
    <>
      <p className="btn-export" onClick={!isServerSide ? exportCSV : onClick}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.5774 7.74538L10.8333 10.4895V1.66797H9.16663V10.4895L6.42255 7.74538L5.24404 8.92389L9.99996 13.6798L14.7559 8.92389L13.5774 7.74538ZM18.3333 16.668V13.3346H16.6666V16.668H3.33329V13.3346H1.66663V16.668C1.66663 17.5884 2.41282 18.3346 3.33329 18.3346H16.6666C17.5871 18.3346 18.3333 17.5884 18.3333 16.668Z"
            fill="black"
          />
        </svg>
        <span>{t(translationConstants.downloadList)}</span>
      </p>
      {!isServerSide && (
        <CSVLink
          target="_blank"
          ref={csvLinkRef}
          headers={columns}
          data={dataToExport}
          filename={filename + ".csv"}
        />
      )}
    </>
  );
};

export default ExportComponent;
